//
import Model from '@/models/Model'
import ConfirmEditModel from '@/models/Actions/AConfirmEdit'
import EditModel from '@/models/Actions/AEdit'
import ProductModel from '@/models/Warehouse/WhProduct'

//
export default class PosSale extends Model {
    //
    global_discount = 0
    global_discount_amount = 0
    invoice_total_edited = 1
    pos_detail_sales_original = []
    //pos_detail_sales_edited = []

    /**
     *
     */
    confirm() {
        return this.hasMany(ConfirmEditModel).replace({
            confirm_or_reject: true,
        })
    }

    /**
     *
     */
    edit() {
        return this.hasMany(EditModel).replace({
            global_discount: this.global_discount,
            global_discount_amount: this.global_discount_amount,
            total: this.invoice_total_edited,
            sale_detail: this.pos_detail_sales_edited.map(
                this.formatBackendDetailSalesEdited
            ),
        })
    }

    /**
     *
     */
    get discount_or_charge_amount_edited() {
        return this.global_discount_amount
    }

    /**
     *
     */
    set discount_or_charge_amount_edited(amount) {
        this.global_discount_amount = amount
    }

    /**
     *
     */
    get can_confirm() {
        return this.g_state_id === 35
    }

    /**
     *
     */
    get can_edit() {
        return this.g_state_id === 17
    }

    /**
     *
     */
    get has_g_state () {
        return !! this.g_state
    }
    
    /**
     * 
     */
    get has_pos_sale_type_id () {
        return !! this.pos_sale_type_id
    }

    /**
     * 
     */
    get g_branch_office_address () {
        return this.g_branch_office.address
    }

    /**
     *
     */
    get g_seller_user_full_name() {
        return [
            this.g_seller_user.hr_employee.names,
            this.g_seller_user.hr_employee.last_name1,
            this.g_seller_user.hr_employee.last_name2,
        ].join(' ')
    }

    /**
     *
     */
    get g_state_name() {
        return this.g_state.state
    }

    get invoice_subtotal_edited() {
        return this.getProperty('pos_detail_sales_edited', []).reduce((total, item) => {
            return ((item.priceProduct * item.quantityProduct) - item.discountValueProduct)+total
        }, 0).toFixed(2)
        //return 0
        //return Math.round(this.invoice_total_edited * 0.19)
    }

    get invoice_iva_edited() {
        //
        const { discount_or_charge_percentage_edited, invoice_subtotal_edited } = this
        const new_subtotal = invoice_subtotal_edited * 1.19
        const new_discount = discount_or_charge_percentage_edited / 100
        //
        this.invoice_total_edited = Math.max(Math.round(new_subtotal * ( 1 - new_discount )), 0)
        //
        return Math.round(this.invoice_subtotal_edited * 0.19)
    }

    /**
     * 
     */
    get invoiceDataPurchaseOrder() {
        return this.getProperty('invoice_data.purchase_order', '')
    }

    /**
     *
     */
    get pos_sale_pos_payment_types_str () {
        return this.pos_sale_pos_payment_types.length ? this.pos_sale_pos_payment_types.map( ({ pos_sale_payment_type }) => pos_sale_payment_type.type ).join(", ") : "Sin especificar"
    }

    /**
     *
     */
    get pos_sale_type_name() {
        return this.pos_sale_type.type
    }

    /**
     *
     */
    get sl_customer_alias_name() {
        return this.sl_customer ? this.sl_customer.alias_name : '-'
    }

    /**
     *
     */
    get sl_customer_rut() {
        return this.sl_customer ? this.sl_customer.rut : ''
    }

    /**
     *
     */
    static includes = [
        'g_branch_office',
        'g_cashier_user.hr_employee',
        'g_seller_user.hr_employee',
        'g_state',
        //"g_supervisor_user.hr_employee",
        'pos_cash_desk',
        'pos_customer_credit_option',
        'pos_manual_discount',
        'pos_sale_pos_payment_types.pos_sale_payment_type',
        'pos_detail_sales.wh_product',
        'pos_detail_sales.wh_warehouse',
        // 'pos_sale_edited.pos_detail_sale_edited',
        "pos_sale_edited.pos_detail_sale_edited.wh_product",
        "pos_sale_edited.pos_detail_sale_edited.wh_warehouse",
        'pos_sale_note',
        'pos_sale_type',
        'sl_customer',
        'sl_customer_branch_offices',
        'sl_customer_branch_offices.g_commune',
        'sl_sale_ticket',
        //"sl_sale_invoice.sl_customer_account_receivable",
        'wh_sale_note',
    ]

    findBranchOffice(branch_office) {
        return branch_office.g_branch_office_id
    }

    findSalePrice(sale_price) {
        return sale_price.branch_office_id
    }

    priceProduct() {
        try {
            const sale_price = this.sale_prices.find(this.findSalePrice)
            return sale_price ? sale_price.sale_price : 0
        } catch (e) {
            return `e: ${e}`
        }
    }

    /**
     *
     */
    mapDetail(item) {
        return new ProductModel({
            ...item.wh_product,
            discount_or_charge_percentage: item.discount_or_charge_percentage,
            discount_or_charge_value: item.discount_or_charge_value,
            id: item.wh_product_id,
            price: item.net_price,
            quantity: item.quantity,
            wh_warehouse: item.wh_warehouse,
            wh_warehouse_id: item.wh_warehouse_id,
        })
    }

    mapNewDetail(item) {
        let obj = {}
        obj.name = item.wh_product.name
        obj.alias_name = item.wh_product.alias_name
        obj.discountPercentageProduct = item.discount_or_charge_percentage
        obj.discountValueProduct = item.discount_or_charge_value
        obj.id = item.wh_product_id
        obj.priceProduct = item.net_price
        obj.quantityProduct = item.quantity
        obj.wh_warehouse_id = item.wh_warehouse_id
        obj.wh_warehouse = item.wh_warehouse
        return obj
    }

    /**
     *
     */
    formatBackendDetailSalesEdited(data) {
        return {
            product_id: data.id,
            quantity: data.quantityProduct,
            price: data.priceProduct*1.19,
            discount: data.discountPercentageProduct,
            discount_unit_price: data.discountValueProduct,
            wh_warehouse_id: data.wh_warehouse.id | data.wh_warehouse_id,
        }
    }

    /**
     *
     */
    reject() {
        return this.hasMany(ConfirmEditModel).replace({
            confirm_or_reject: false,
        })
    }

    /**
     *
     */
    reset() {
        //
        this.discount_or_charge_amount_edited = this.pos_sale_edited
            ? this.pos_sale_edited.discount_or_charge_amount
            : 0
        this.discount_or_charge_percentage_edited = this.pos_sale_edited
            ? this.pos_sale_edited.discount_or_charge_percentage
            : 0
        this.invoice_total_edited = this.pos_sale_edited
            ? this.pos_sale_edited.invoice_total
            : 0
        this.pos_detail_sales_edited = this.pos_sale_edited
            ? this.pos_sale_edited.pos_detail_sale_edited.map(this.mapNewDetail)
            : this.pos_detail_sales.map(this.mapNewDetail)
        this.pos_detail_sales_original = this.pos_detail_sales.map(
            this.mapDetail
        )

        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'pos_sale'
    }
}
